import React from 'react';
import { motion } from 'framer-motion';
import Navigation from './components/Navigation';
import Hero from './components/Hero';
import Problem from './components/Problem';
import Solution from './components/Solution';
import Benefits from './components/Benefits';
import Results from './components/Results';
import Comparison from './components/Comparison';
import HowItWorks from './components/HowItWorks';
import About from './components/About';
import FAQ from './components/FAQ';
import QuizCTA from './components/QuizCTA';
import Contact from './components/Contact';
import Urgency from './components/Urgency';
import Footer from './components/Footer';
import './App.css';

function App() {
  return (
    <div className="App">
      <Navigation />
      
      <motion.main
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.5 }}
      >
        <Hero />
        <Problem />
        <Solution />
        <Benefits />
        <Results />
        <Comparison />
        <HowItWorks />
        <About />
        <FAQ />
        <QuizCTA />
        <Contact />
        <Urgency />
      </motion.main>
      
      <Footer />
    </div>
  );
}

export default App;